import { MALUKU_ROUTE_NAMES } from '../router/malukuRoutes';

export const SITE_NAVIGATION = Object.freeze([
    {
        id: 'home',
        labelKey: 'nav.home',
        path: '/',
        routeNames: ['Home', 'HomeByLocale', 'HomeLocale'],
    },
    {
        id: 'tree',
        labelKey: 'nav.tree',
        children: [
            {
                id: 'tree-network',
                labelKey: 'nav.treeNetwork',
                path: '/stamboom',
                routeName: 'Stamboom',
                view: 'personen',
            },
            {
                id: 'tree-surnames',
                labelKey: 'nav.treeSurnames',
                path: '/stamboom?view=achternamen',
                routeName: 'Stamboom',
                view: 'achternamen',
            },
            {
                id: 'tree-family-members',
                labelKey: 'nav.treeFamilyMembers',
                path: '/stamboom?view=relaties',
                routeName: 'Stamboom',
                view: 'relaties',
            },
        ],
    },
    {
        id: 'stories',
        labelKey: 'nav.stories',
        path: '/verhalen',
        routeNames: ['BlogOverview', 'BlogPost'],
    },
    {
        id: 'explore',
        labelKey: 'nav.explore',
        children: [
            { id: 'discoveries', labelKey: 'nav.exploreNew', path: '/nieuw', routeName: 'RecentChanges' },
            { id: 'media', labelKey: 'nav.exploreMedia', path: '/fotos-en-documenten', routeName: 'MediaOverview' },
            { id: 'places', labelKey: 'nav.explorePlaces', path: '/plaatsen', routeNames: ['PlaceOverview', 'PlaceEvents'] },
            { id: 'maluku', labelKey: 'nav.exploreMaluku', badgeKey: 'nav.newLabel', path: '/maluku', routeNames: MALUKU_ROUTE_NAMES },
            { id: 'calendar', labelKey: 'nav.exploreCalendar', path: '/kalender', routeName: 'EventCalendar' },
            { id: 'dna', labelKey: 'nav.exploreDna', path: '/dna', routeName: 'GeneticMatches' },
            { id: 'research', labelKey: 'nav.exploreResearch', path: '/gezocht', routeName: 'ResearchPage' },
            { id: 'statistics', labelKey: 'nav.exploreStats', path: '/statistieken', routeNames: ['SiteStatsOverview', 'SiteStatsGrowth'] },
        ],
    },
    {
        id: 'about',
        labelKey: 'nav.about',
        children: [
            { id: 'about-project', labelKey: 'nav.aboutProject', path: '/over', routeName: 'AboutPage' },
            { id: 'contact', labelKey: 'nav.aboutContact', path: '/contact', routeName: 'ContactPage' },
        ],
    },
]);

export const PRERENDER_NAVIGATION_LINKS = Object.freeze(
    SITE_NAVIGATION.flatMap(item => item.path ? [item] : item.children || [])
);
